<template>
	<validation-provider
			:name="'AdminSelectGroupCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctScrtyGrpCd_contentAppSecurityGroups())"
				item-text="key"
				item-value="key"
				placeholder="Group Code"
				@change="$_admnSlctScrtyGrpCd_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectSecurityGroupCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctScrtyGrpCd_contentAppSecurityGroups() {
				const self_ = this;
				return () => {
					const contents_ = self_.getAppContents('securityGroups')
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			}
		},
		methods: {
			$_admnSlctScrtyGrpCd_setAdminState() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				const code_ = input_[self_.inputItemKey]

				const securityGroups_ = self_.$_admnSlctScrtyGrpCd_contentAppSecurityGroups()
				input_.securityGroupName = securityGroups_[code_].title;

				self_.setAdminState('input', input_)
			}
		}
	}
</script>

<style scoped>
</style>
